import { useTranslations } from "@zapier/i18n";

/**
 * `useTranslations` for a runtime (non-literal) namespace. next-intl's typed
 * overload only accepts a known namespace literal, but the config-driven
 * FilterBar receives the namespace as a string from each asset — so the cast
 * lives here once instead of being repeated at every call site.
 */
export function useNamespacedTranslations(namespace: string) {
  return useTranslations(
    namespace as Parameters<typeof useTranslations>[0],
  ) as (key: string, values?: Record<string, unknown>) => string;
}
